// import { http } from "@/utils/http";

type Result = {
  success: boolean;
  data: Array<any>;
};

export const getAsyncRoutes = () => {
  return new Promise<Result>(resolve => {
    const res = {
      success: true,
      data: []
    };
    setTimeout(() => {
      resolve(res);
    }, 100);
  });
  // return http.request<Result>("get", "/get-async-routes");
};
